import { IconButton, Badge, Box } from '@mui/material';
import { styled } from '@mui/system';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { matchesOtherProductCategories } from './filterMatchesOtherProductCategories';

const matchesCatalogCategoryFilter = (params, col, matches) => {
  const { value } = params;
  const { field } = col;
  if (matches(value)) return true;
  return matchesOtherProductCategories(params.row, field, matches);
};

export function createColumns(COLUMNS, filters, setAnchorEl, setActiveFilter, key, activeFilter) {

  let columns = COLUMNS.map((col) => {
    if (col?.type === 'customSelect') {
      return {
        ...col,
        filterOperators: [
          {
            value: 'isAnyOf',
            label: 'is any of',
            getApplyFilterFn: (filterItem) => {
              if (
                !filterItem ||
                !filterItem?.value ||
                !Array.isArray(filterItem?.value) ||
                filterItem?.value.length === 0
              ) {
                return null;
              }
              if (col?.customType === "catalogCategory") {
                return (params) => matchesCatalogCategoryFilter(params, col, (fieldValue) => filterItem?.value?.includes(fieldValue));
              }
              return (params) => {
                const { value } = params;
                if (Array.isArray(value)) {
                  return filterItem.value.some((fv) => value.includes(fv));
                }
                return filterItem?.value?.includes(value);
              };
            },
          },
          {
            value: 'contains',
            label: 'contains',
            getApplyFilterFn: (filterItem) => {
              if (!filterItem || !filterItem?.value) {
                return null;
              }
              const search = filterItem?.value?.toLowerCase();
              return (params) => {
                const { value } = params;
                if (col.customType === "catalogCategory") {
                  return matchesCatalogCategoryFilter(params, col, (fieldValue) => String(fieldValue)?.toLowerCase()?.includes(search));
                }
                return value ? String(value)?.toLowerCase()?.includes(search) : false;
              };
            },
          },
          {
            value: 'containsAnySubstring',
            label: 'Contains any substring',
            getApplyFilterFn: (filterItem) => {
              if (!filterItem || !filterItem?.value) {
                return null;
              }
              const search = filterItem.value.toLowerCase();
              return (params) => {
                const { value } = params;
                let arr = value;
                if (typeof value === "string") {
                  arr = value.split(",").map(v => v.trim());
                }
                if (!Array.isArray(arr)) return false;
                return arr.some((v) => v.toString().toLowerCase().includes(search));
              };
            },
          },
          {
            label: 'Has any of',
            value: 'hasAnyOf',
            getApplyFilterFn: (filterItem) => {
              if (
                !filterItem.value ||
                !Array.isArray(filterItem.value) ||
                filterItem.value.length === 0
              ) {
                return null;
              }

              const filterValues = filterItem.value;
              return ({ value }) => {
                let arr = value;
                if (typeof value === "string") {
                  arr = value.split(",").map(v => v.trim());
                }
                if (!Array.isArray(arr)) return false;
                return arr.some((v) => filterValues.includes(v));
              };
            },
          }
        ],
        renderHeader: (params) => (
          <Box draggable="true" sx={{ p: 1 }}>
            {col?.checkBox && col.checkBox()}
            {params?.colDef?.headerName}
            <Box
              component="span"
              onClick={(event) => {
                event.stopPropagation();
                setAnchorEl(event.currentTarget);
                setActiveFilter(col.field);
              }}
            >
              <StyledBadge badgeContent={filters[col.field]?.value?.length} color="info">
                <IconButton
                  disabled={activeFilter && activeFilter !== col.field}
                  color={filters[col.field]?.value?.length ? 'secondary' : 'white'}
                  sx={{
                    cursor: 'pointer',
                  }}
                >
                  <FilterAltIcon
                    sx={{
                      height: activeFilter === col.field ? '30px' : '17px',
                    }}
                  />
                </IconButton>
              </StyledBadge>
            </Box>
          </Box>
        ),
      };
    }
    if (col?.type === 'customNumber') {
      return {
        ...col,
        //sortable: false,
        filterable: false,
        filterOperators: [
          {
            value: '=',
            label: '=',
            getApplyFilterFn: (filterItem) => {
              if (
                !filterItem ||
                !filterItem?.value ||
                !Array.isArray(filterItem?.value) ||
                filterItem?.value.length === 0
              ) {
                return null;
              }
              return (params) => {
                const { value } = params;
                return filterItem?.value?.includes(value);
              };
            },
          },
          {
            value: 'contains',
            label: 'contains',
            getApplyFilterFn: (filterItem) => {
              if (!filterItem || !filterItem?.value) {
                return null;
              }
              return (params) => {
                const { value } = params;
                return value ? String(value)?.includes(filterItem?.value) : false;
              };
            },
          },
        ],
        renderHeader: (params) => (
          <Box draggable="true">
            {params?.colDef?.headerName}
            <Box
              component="span"
              onClick={(event) => {
                event.stopPropagation();
                setAnchorEl(event.currentTarget);
                setActiveFilter(col.field);
              }}
            >
              <StyledBadge badgeContent={filters[col.field]?.value ? 1 : 0} color="info">
                <IconButton
                  disabled={activeFilter && activeFilter !== col.field}
                  color={filters[col.field]?.value?.length ? 'secondary' : 'white'}
                  sx={{
                    cursor: 'pointer',
                  }}
                >
                  <FilterAltIcon
                    sx={{
                      height: activeFilter === col.field ? '30px' : '17px',
                    }}
                  />
                </IconButton>
              </StyledBadge>
            </Box>
          </Box>
        ),
      };
    }
    if (col?.type === 'customMoney') {
      return {
        ...col,
        // //sortable: false,
        // filterable: false,
        filterOperators: [
          {
            value: 'range',
            label: 'range',
            getApplyFilterFn: (filterItem) => {
              if (
                !filterItem ||
                !filterItem?.value ||
                !Array.isArray(filterItem?.value) ||
                filterItem?.value.length !== 2
              ) {
                return null;
              }
              return (params) => {
                const { value } = params;
                return value >= filterItem?.value[0] && value <= filterItem?.value[1];
              };
            },
          },
          {
            value: 'contains',
            label: 'contains',
            getApplyFilterFn: (filterItem) => {
              if (!filterItem || !filterItem?.value) {
                return null;
              }
              return (params) => {
                const { value } = params;
                return value ? String(value)?.includes(filterItem?.value) : false;
              };
            },
          },
        ],
        renderHeader: (params) => (
          <Box draggable="true">
            {params?.colDef?.headerName}
            <Box
              component="span"
              onClick={(event) => {
                event.stopPropagation();
                setAnchorEl(event.currentTarget);
                setActiveFilter(col.field);
              }}
            >
              <StyledBadge badgeContent={filters[col.field]?.value ? 1 : 0} color="info">
                <IconButton
                  disabled={activeFilter && activeFilter !== col.field}
                  color={filters[col.field]?.value?.length ? 'secondary' : 'white'}
                  sx={{
                    cursor: 'pointer',
                  }}
                >
                  <FilterAltIcon
                    sx={{
                      height: activeFilter === col.field ? '30px' : '17px',
                    }}
                  />
                </IconButton>
              </StyledBadge>
            </Box>
          </Box>
        ),
      };
    }
    if (col?.type === 'customText') {
      return {
        ...col,
        // //sortable: false,
        // filterable: false,
        filterOperators: [
          {
            value: 'contains',
            label: 'contains',
            getApplyFilterFn: (filterItem) => {
              if (!filterItem || !filterItem?.value) {
                return null;
              }
              return (params) => {
                const value = String(params.value);
                const filterValue = String(filterItem?.value);
                return value ? value.toLowerCase().includes(filterValue.toLowerCase()) : false;
              };
            },
          },
        ],
        renderHeader: (params) => (
          <Box draggable="true" pr={.5}>
            {col?.checkBox && col.checkBox()}
            {params?.colDef?.headerName}
            <Box
              component="span"
              onClick={(event) => {
                event.stopPropagation();
                setAnchorEl(event.currentTarget);
                setActiveFilter(col.field);
              }}
            >
              <StyledBadge badgeContent={filters[col.field]?.value ? 1 : 0} color="info">
                <IconButton
                  disabled={activeFilter && activeFilter !== col.field}
                  color={filters[col.field]?.value?.length ? 'secondary' : 'white'}
                  sx={{
                    cursor: 'pointer',
                  }}
                >
                  <FilterAltIcon
                    sx={{
                      height: activeFilter === col.field ? '30px' : '17px',
                    }}
                  />
                </IconButton>
              </StyledBadge>
            </Box>
          </Box>
        ),
      };
    }
    if (col?.type === 'customDate') {
      return {
        ...col,
        // //sortable: false,
        // filterable: false,
        filterOperators: [
          {
            value: 'dateRange',
            label: 'date range',
            getApplyFilterFn: (filterItem) => {
              if (
                !filterItem ||
                !filterItem?.value ||
                !Array.isArray(filterItem?.value) ||
                filterItem?.value.length !== 2
              ) {
                return null;
              }
              return (params) => {
                const { value } = params;
                const start = new Date(filterItem?.value[0]);
                const end = new Date(filterItem?.value[1]);
                const val = typeof value === 'string' ? new Date(value.slice(1)) : new Date(value); //in orders tables the date gets concatinated as a string with a number in front for sorting, so removing the number where it exists
                return start <= val && val <= end;
              };
            },
          },
          {
            value: 'contains',
            label: 'contains',
            getApplyFilterFn: (filterItem) => {
              if (!filterItem || !filterItem?.value) {
                return null;
              }
              return (params) => {
                const { value } = params;
                return value ? String(value)?.includes(filterItem?.value) : false;
              };
            },
          },
        ],
        renderHeader: (params) => (
          <Box draggable="true">
            {params?.colDef?.headerName}
            <Box
              component="span"
              onClick={(event) => {
                event.stopPropagation();
                setAnchorEl(event.currentTarget);
                setActiveFilter(col.field);
              }}
            >
              <StyledBadge badgeContent={filters[col.field]?.value ? 1 : 0} color="info">
                <IconButton
                  disabled={activeFilter && activeFilter !== col.field}
                  color={filters[col.field]?.value?.length ? 'secondary' : 'white'}
                  sx={{
                    cursor: 'pointer',
                  }}
                >
                  <FilterAltIcon
                    sx={{
                      height: activeFilter === col.field ? '30px' : '17px',
                    }}
                  />
                </IconButton>
              </StyledBadge>
            </Box>
          </Box>
        ),
      };
    }

    return { ...col, filterable: false };
  });

  // Always force 'actions' column last
  if (Array.isArray(columns)) {
    const withoutActions = columns.filter(col => col.field !== 'actions');
    const actionsCol = columns.find(col => col.field === 'actions');
    if (actionsCol) columns = [...withoutActions, actionsCol];
  }
  return columns;
}

const StyledBadge = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    backgroundColor: 'transparent', // Remove background color
    color: theme.palette.secondary.main, // Set text color to secondary
    boxShadow: 'none', // Remove any shadow or outline
    mr: 1,
  },
}));
